import 'chart.js/auto';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HOME, isLoggedIn } from '../../Utils/Utils';
import internet from '../../assets/images/Internet.png';

export const HomePage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (isLoggedIn()) {
            navigate(HOME + '/home')
        } else {
            navigate('/')
        }
    }, [])
    return (
        <div className="p-3 bg-white">
            <div className="text-center">
                <img src={internet} alt="" className='m-auto' height={450} width={450} />
                <h1 className="text-3xl font-bold tracking-tight text-amber-400 sm:text-5xl font-mtn">FTTH SALES FORCES AUTOMATION</h1>
                <p className="mt-2 text-base leading-7 text-gray-600">
                    Une plateforme de suivie du processus d'aquisition de la Fibre optique.
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <Link to={`${HOME}/abonnements/enregistrement-intention`}
                        className="rounded-md bg-main px-3.5 py-2.5 text-sm font-semibold text-black shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Faire une demande
                    </Link>
                    <Link to={`${HOME}/abonnements`} className="text-sm font-semibold text-gray-900">
                        Liste des demandes <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}
